'use client';

import type { InteractionType } from '~/model/InteractionType';
import { VpIcon } from '@vtmn-play/react/headless';
import { format } from 'date-fns';
import { useLocale } from 'next-intl';
import { InteractionUserStatus } from '@/app/[locale]/(entity)/components/interaction/InteractionUserStatus';
import { MainCta } from '@/app/[locale]/(entity)/components/interaction/MainCta/MainCta';
import { useAuthenticatedContext } from '@/app/components/Provider';
import { useRouter } from '@/i18n/routing';
import { InteractionTagSticker } from '~/components/Interaction/common/InteractionTagSticker/InteractionTagSticker';
import appConst from '~/const/appConst';
import { getRouteFromType } from '~/utils/utils';

export const ProjectStep = ({
  interaction,
}: {
  interaction: InteractionType;
}) => {
  const locale = useLocale();
  const router = useRouter();

  const { isAuthenticated, redirectToLogin } = useAuthenticatedContext();
  const interactionType = interaction['@type'];

  const interactionRoute = getRouteFromType(interactionType);
  const interactionUrl = `/${interactionRoute}/${interaction.id}`;

  const handleParticipate = async () => {
    if (!isAuthenticated)
      await redirectToLogin(interactionUrl);
    else
      router.push(interactionUrl);
  };

  return (
    <div data-testid="step-block" className="step__block">
      <div className="step__content">
        <InteractionTagSticker interaction={interaction} />
        <h2 className="vp-title-m">{interaction?.title}</h2>
        <InteractionUserStatus interaction={interaction} />
        <div className="step__date">
          <VpIcon className="step__icon" name="calendar" size={20} />
          {interaction
            && format(new Date(interaction.start_at), 'dd MMM yyyy', {
              locale: appConst.locales[locale],
            })}
        </div>
      </div>
      <div className="step__action">
        <MainCta
          interaction={interaction}
          handleParticipate={handleParticipate}
        />
      </div>
    </div>
  );
};
